<template>
    <section>
        <template v-if="!busy">
            <b-alert
                variant="warning"
                show
            >Solange keine Beträge für die verschiedenen Probentypen angegeben werden, werden auch keine Gastsängerabrechnung für dieses Mitglied vorgenommen</b-alert>
            <b-form-group
                v-for="field in data"
                :key="field.key"
                :label-cols-sm="4"
                :label-cols-lg="6"
                :label-for="field.key"
                :label="field.label"
                :label-size="size"
            >
                <b-input-group>
                    <b-input :id="field.key" v-model="field.betrag" placeholder="Betrag in €" />
                    <b-input-group-append is-text>€</b-input-group-append>
                </b-input-group>
            </b-form-group>
        </template>
        <template v-else>
            <CenteredMessage :spinner="true">
                <template #title>Probenvergütungen werden geladen</template>
            </CenteredMessage>
        </template>
    </section>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Size from "@/mixins/Size/Size";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

import "./MitgliederProbenbenefit.scss";

const ProbentypApi = ApiFactory.get("probentyp");

export default {
    name: "MitgliederProbenbenefit",
    mixins: [Size],
    props: ["id"],
    components: {
        CenteredMessage
    },
    data() {
        return {
            data: [],
            busy: false
        };
    },
    watch: {
        id: {
            handler(val) {
                this.fetch();
            },
            immediate: true
        },
        data: {
            handler(val) {
                this.$emit("change", this.data);
            },
            deep: true
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            if (this.id) {
                const response = await ProbentypApi.getBenefit(this.id);
                if (response.ok) {
                    const items = response.json.collection;
                    this.data = items.map(item => {
                        return Object.assign(
                            {
                                key: "ptb_" + item.pk_typ,
                                label:
                                    item.bezeichnung + " <" + item.kuerzel + ">"
                            },
                            item
                        );
                    });
                }
            }
            this.busy = false;
        }
    }
};
</script>
